import React, { useState, useEffect, useRef } from 'react';
// import { appInsights, reactPlugin } from '../../../appInsights';
// import { withAITracking } from '@microsoft/applicationinsights-react-js';
import { jsonEditorStyles } from '../jsonEditorStyles';
import cn from 'clsx';
import Button from '@mui/material/Button';
import FormControl from '@mui/material/FormControl';
import { SelectChangeEvent } from '@mui/material';
import { Box, Typography, Divider } from '@mui/material';
import { Menu, MenuItem } from '@mui/material';
import { TextComponent, SelectComponent } from '../../uiComponents';
import { OptionProps } from '../../../view-models';
import jsonComponentsConfig from '../../../constants/jsonComponents';
import useComponentUIHook from './useComponentUIHook';
import SessionManagement from './sessionManagement';
import DeleteIcon from '@mui/icons-material/Delete';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { cloneDeep } from 'lodash';
import constants from '../../../constants/constants';

const styles1 = makeStyles((theme: Theme) =>
  createStyles({
    groupName: {
      flexBasis: 100,
      backgroundColor: '#cecece',
      borderLeft: '1px solid black',
      borderTop: '1px solid black',
      borderBottom: '1px solid black',
      padding: 10,
      textAlign: 'center',
    },
    groupContent: {
      flex: 1,
      padding: 10,
      borderRight: '1px solid black',
      borderTop: '1px solid black',
      borderBottom: '1px solid black',
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'wrap',
    },
  }),
);

interface componentProps {
  componentData: any;
  closeGritComponent: any;
  setUnsavedChanges: any;
}
interface Condition {
  claim: string;
  operator: string;
  compareTo: string;
  comValue: string;
  option?: string;
}
const GenerateConditionalUI = ({ componentData, closeGritComponent, setUnsavedChanges }: componentProps) => {
  const configData = jsonComponentsConfig.conditionals.data;
  const initCondition = useRef(componentData['condition']);
  const classes = jsonEditorStyles();
  const classes1 = styles1();
  const [groups, setGroups] = useState<Condition[][]>(componentData['groups']);
  const [enableCondBt, setEnableCondBt] = useState(false);
  const { modifiedData, setModifiedData, checkIfSameIgnoringSubFlows, allClaims } = useComponentUIHook(componentData);
  const [disableSubmit, setDisableSubmit] = useState<boolean>(false);
  const [dropDownBt, setDropDownBt] = React.useState<null | HTMLElement>(null);
  const open = Boolean(dropDownBt);
  const handleDropDownBtClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setDropDownBt(event.currentTarget);
  };
  const handleDropDownBtClose = () => {
    setDropDownBt(null);
  };
  const addCondition = (num: number) => {
    if (num < 0) {
      // creating new group
      setGroups((prv: any) => [
        ...prv,
        [
          {
            claim: modifiedData.condition.claim,
            operator: modifiedData.condition.operator,
            compareTo: modifiedData.condition.compareTo,
            comValue: (['exists', 'does not exist'].includes(modifiedData.condition.operator)) ? '' : modifiedData.condition.comValue,
            option: modifiedData.condition.option,
            dateTimeOffset: modifiedData.condition.dateTimeOffset,
          },
        ],
      ]);
    } else {
      // adding to existing group
      setGroups((prv: any) =>
        prv.map((p: Condition[], i: number) =>
          i === num
            ? [
                ...p,
                {
                  claim: modifiedData.condition.claim,
                  operator: modifiedData.condition.operator,
                  compareTo: modifiedData.condition.compareTo,
                  comValue: modifiedData.condition.comValue,
                  option: modifiedData.condition.option,
                  dateTimeOffset: modifiedData.condition.dateTimeOffset,
                },
              ]
            : p,
        ),
      );
    }
    setModifiedData({ ...modifiedData, condition: initCondition.current });
    setDropDownBt(null);
  };
  const submitData = (data: any, addFormSubmitAction: boolean) => {
    setDisableSubmit(false);
    closeGritComponent(data, null, addFormSubmitAction);
  };
  useEffect(() => {
    const _res: boolean = checkIfSameIgnoringSubFlows();
    setDisableSubmit(_res);
    setUnsavedChanges(_res);
    setEnableCondBt(
      modifiedData.condition?.claim &&
      modifiedData.condition?.operator &&
      (((allClaims[modifiedData.condition.claim].dataType === 'string') &&
        (
          (['==', '!='].includes(modifiedData.condition?.operator) &&
            (
              (modifiedData.condition?.compareTo === 'literal') ||
              ((modifiedData.condition?.compareTo === 'claim') &&
                Object.keys(allClaims).includes(modifiedData.condition?.comValue) &&
                (allClaims[modifiedData.condition?.comValue].dataType === 'string')
              ) ||
              ((modifiedData.condition?.compareTo === 'sessionContext') &&
                constants.SESSIONCONTEXT.some((sc) => { return sc.value === modifiedData.condition?.comValue; })
              )
            )
          ) || (
            (modifiedData.condition?.operator === 'contains') &&
            modifiedData.condition?.comValue
          )
        )
      ) || ((allClaims[modifiedData.condition?.claim].dataType === 'boolean') &&
        configData.operator.boolean.includes(modifiedData.condition?.operator) &&
        (
          (
            (modifiedData.condition?.compareTo === 'literal') &&
            ['true', 'false'].includes(modifiedData.condition?.comValue)
          ) ||
          (
            (modifiedData.condition?.compareTo === 'claim') &&
            Object.keys(allClaims).includes(modifiedData.condition?.comValue) &&
            (allClaims[modifiedData.condition?.comValue].dataType === 'boolean') 
          )
        )
        ) || ((allClaims[modifiedData.condition?.claim].dataType === 'dateTime') &&
          (
            (['==', '<=', '>='].includes(modifiedData.condition?.operator) &&
              (
                (
                  (modifiedData.condition?.compareTo === 'claim') &&
                  Object.keys(allClaims).includes(modifiedData.condition?.comValue) &&
                  (allClaims[modifiedData.condition?.comValue].dataType === 'dateTime')
                ) || (
                  (modifiedData.condition?.compareTo === 'sessionContext') &&
                  constants.SESSIONCONTEXT.some((sc) => { return sc.value === modifiedData.condition?.comValue; })
                )
              )
            ) ||
            ['exists', 'does not exist'].includes(modifiedData.condition?.operator)
          )
        )
      )
    );
  }, [modifiedData]);

  useEffect(() => {
    setModifiedData({ ...modifiedData, groups: groups });
  }, [groups]);

  return (
    <>
      <FormControl required sx={{ m: 1, minWidth: 800 }}>
        <Box>
          <Typography gutterBottom variant="body1">
            Group Conditions : <b>Conditions are AND ed and Groups are OR ed</b>
          </Typography>
          {modifiedData['groups'].map((g: any, num: number) => {
            return (
              <div key={num} className={classes.flexCol}>
                <div className={classes.flexRow}>
                  <div className={classes1.groupName}>Group {num}</div>
                  <div className={classes1.groupContent}>
                    {g.map((i: any, k: number) => {
                      let conditionStr: string = i.claim;
                      if (
                        allClaims[i.claim]['dataType'] === 'dateTime' &&
                        i.operator !== 'exists' &&
                        i.operator !== 'does not exist'
                      ) {
                        let dtsElem = '';
                        if (parseInt(i.dateTimeOffset) !== 0) {
                          dtsElem = parseInt(i.dateTimeOffset) > 0 ? '+' : '-';
                        }
                        conditionStr += ' ' + dtsElem + i.dateTimeOffset + 's';
                      }
                      conditionStr += ' ' + i.operator + ' ';
                      i.compareTo === 'literal' && allClaims[i.claim]['dataType'] === 'string'
                        ? (conditionStr += '"' + i['comValue'] + '"')
                        : (conditionStr += i['comValue']);
                      if (allClaims[i.claim]['dataType'] === 'string') conditionStr += '(' + i['option'] + ')';

                      return (
                        <div key={k} className={classes.flexRow}>
                          {conditionStr}
                          <DeleteIcon
                            onClick={() => {
                              if (
                                window.confirm(
                                  'Are you sure you want to delete the condition,\n' +
                                    conditionStr +
                                    ' ?\nThis cannot be undone.',
                                )
                              ) {
                                setGroups((prv: any) =>
                                  prv
                                    .map((p: Condition[], l: number) =>
                                      l === num ? p.filter((m: Condition, j: number) => j !== k) : p,
                                    )
                                    .filter((p: Condition[]) => p.length),
                                );
                              }
                            }}
                            className={classes.icon}
                            color="error"
                          />

                          {k !== g.length - 1 && (
                            <>
                              &nbsp;&nbsp;&nbsp;
                              <b>&&</b>
                              &nbsp;&nbsp;&nbsp;
                            </>
                          )}
                        </div>
                      );
                    })}
                  </div>
                </div>
                {num !== modifiedData['groups'].length - 1 && <div style={{ textAlign: 'center' }}>OR</div>}
              </div>
            );
          })}
          <Divider sx={{ mt: 1, mb: 1 }} />
          <div className={classes.flexRow}>
            <SelectComponent
              changeHandler={(e: SelectChangeEvent<string>) => {
                setModifiedData({
                  ...modifiedData,
                  condition: {
                    ...modifiedData['condition'],
                    claim: e.target.value,
                    operator:
                      modifiedData['condition']?.operator &&
                      e.target.value &&
                      allClaims[e.target.value] &&
                      configData.operator[
                        allClaims[e.target.value].dataType as keyof typeof configData.operator
                      ]?.includes(modifiedData['condition']?.operator)
                        ? modifiedData['condition']?.operator
                        : '',
                    compareTo:
                      modifiedData['condition']?.compareTo &&
                      e.target.value &&
                      allClaims[e.target.value] &&
                      configData.compareTo[
                        allClaims[e.target.value].dataType as keyof typeof configData.compareTo
                      ]?.includes(modifiedData['condition']?.compareTo)
                        ? modifiedData['condition']?.compareTo
                        : '',
                    dateTimeOffset: modifiedData['condition']?.dateTimeOffset
                      ? modifiedData['condition']?.dateTimeOffset
                      : '0',
                  },
                });
              }}
              data={{
                value: modifiedData.condition?.claim || '',
                label: 'Claim',
                style: { margin: 1, width: 150 },
                required: true,
                options: Object.keys(allClaims)
                  // .filter((c) => !selClaims.find((s) => s === c))
                  .reduce((acc: OptionProps[], curVal: string) => acc.concat({ label: curVal, value: curVal }), [])
                  .sort((a: OptionProps, b: OptionProps) => (a.value.toLowerCase() > b.value.toLowerCase() ? 1 : -1)),
              }}
            />
            <SelectComponent
              changeHandler={(e: SelectChangeEvent<string>) => {
                setModifiedData({
                  ...modifiedData,
                  condition: {
                    ...modifiedData['condition'],
                    operator: e.target.value,
                    compareTo:
                      modifiedData['condition']?.compareTo &&
                      modifiedData['condition']?.operator !== 'exists' &&
                      modifiedData['condition']?.operator !== 'does not exist'
                        ? modifiedData['condition'].compareTo
                        : '',
                    comValue:
                      modifiedData['condition']?.comValue &&
                      modifiedData['condition']?.operator !== 'exists' &&
                      modifiedData['condition']?.operator !== 'does not exist'
                        ? modifiedData['condition']?.comValue
                        : '',
                  },
                });
              }}
              data={{
                value:
                  modifiedData.condition?.operator &&
                  modifiedData.condition?.claim &&
                  configData.operator[
                    allClaims[modifiedData.condition?.claim].dataType as keyof typeof configData.operator
                  ]?.includes(modifiedData.condition?.operator)
                    ? modifiedData.condition?.operator
                    : '',
                label: 'Operator',
                required: true,
                style: { margin: 1, width: 110 },
                options: allClaims[modifiedData.condition?.claim]
                  ? configData.operator[
                      allClaims[modifiedData.condition?.claim].dataType as keyof typeof configData.operator
                    ]
                    ? configData.operator[
                        allClaims[modifiedData.condition?.claim].dataType as keyof typeof configData.operator
                      ].map((o: string) => ({ label: o, value: o }))
                    : []
                  : [],
              }}
            />
            {modifiedData.condition?.operator !== 'exists' && modifiedData.condition?.operator !== 'does not exist' && (
              <>
                {modifiedData.condition?.operator !== 'contains' && (
                  <SelectComponent
                    changeHandler={(e: SelectChangeEvent<string>) => {
                      setModifiedData({
                        ...modifiedData,
                        condition: {
                          ...modifiedData['condition'],
                          compareTo: e.target.value,
                        },
                      });
                    }}
                    data={{
                      value:
                        modifiedData.condition?.compareTo &&
                          modifiedData.condition?.claim &&
                          configData.compareTo[
                            allClaims[modifiedData.condition?.claim].dataType as keyof typeof configData.compareTo
                          ]?.includes(modifiedData.condition?.compareTo)
                          ? modifiedData.condition?.compareTo
                          : '',
                      label: 'CompareTo',
                      required: true,
                      style: { margin: 1, width: 120 },
                      options: allClaims[modifiedData.condition?.claim]
                        ? configData.compareTo[
                          allClaims[modifiedData.condition?.claim].dataType as keyof typeof configData.compareTo
                        ]
                          ? configData.compareTo[
                            allClaims[modifiedData.condition?.claim].dataType as keyof typeof configData.compareTo
                          ].map((o: string) => ({ label: o, value: o }))
                          : []
                        : [],
                    }}
                  />
                )}
                {modifiedData.condition?.claim &&
                  ((modifiedData.condition?.operator === 'contains') || (modifiedData.condition?.compareTo === 'literal')) &&
                  allClaims[modifiedData.condition?.claim].dataType === 'string' && (
                    <TextComponent
                      changeHandler={(e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
                        setModifiedData({
                          ...modifiedData,
                          condition: {
                            ...modifiedData['condition'],
                            comValue: e.target.value,
                          },
                        });
                      }}
                      data={{
                        value: modifiedData.condition?.comValue || '',
                        label: 'ComValue',
                        style: { margin: 1, width: 150 },
                      }}
                    />
                  )}
              </>
            )}
            {modifiedData.condition?.claim &&
              (!['exists', 'does not exist'].includes(modifiedData.condition?.operator)) &&
              (modifiedData.condition?.compareTo === 'claim' ||
                (modifiedData.condition?.compareTo === 'literal' &&
                  allClaims[modifiedData.condition?.claim].dataType === 'boolean') ||
                modifiedData.condition?.compareTo === 'sessionContext') && (
                <SelectComponent
                  changeHandler={(e: SelectChangeEvent<string>) => {
                    setModifiedData({
                      ...modifiedData,
                      condition: {
                        ...modifiedData['condition'],
                        comValue: e.target.value,
                      },
                    });
                  }}
                  data={{
                    value: modifiedData.condition?.comValue || '',
                    label: 'ComValue',
                    required: true,
                    style: { margin: 1, width: 150 },
                    options:
                      modifiedData.condition?.compareTo === 'claim'
                        ? Object.entries(allClaims)
                            .filter(
                              ([k, v]: any) =>
                                v.dataType === allClaims[modifiedData.condition?.claim].dataType &&
                                v.id !== modifiedData.condition?.claim,
                            )
                            .map(([k, v]) => k)
                            .reduce(
                              (acc: OptionProps[], curVal: string) => acc.concat({ label: curVal, value: curVal }),
                              [],
                            )
                            .sort((a: OptionProps, b: OptionProps) =>
                              a.value.toLowerCase() > b.value.toLowerCase() ? 1 : -1,
                            )
                        : modifiedData.condition?.compareTo === 'sessionContext'
                        ? constants.SESSIONCONTEXT
                        : [
                            { label: 'true', value: 'true' },
                            { label: 'false', value: 'false' },
                          ],
                  }}
                />
              )}
            {modifiedData.condition?.claim &&
              modifiedData.condition?.claim &&
              allClaims[modifiedData.condition?.claim].dataType === 'string' && (
                <SelectComponent
                  changeHandler={(e: SelectChangeEvent<string>) => {
                    setModifiedData({
                      ...modifiedData,
                      condition: {
                        ...modifiedData['condition'],
                        option: e.target.value,
                      },
                    });
                  }}
                  data={{
                    value: modifiedData.condition?.option || '',
                    label: 'Option',
                    required: true,
                    style: { margin: 1, width: 150 },
                    options: [
                      { label: 'ignorecase', value: 'ignorecase' },
                      { label: 'not ignorecase', value: 'not ignorecase' },
                    ],
                  }}
                />
              )}
            {modifiedData.condition?.claim &&
              allClaims[modifiedData.condition?.claim].dataType === 'dateTime' &&
              modifiedData.condition?.operator !== 'exists' &&
              modifiedData.condition?.operator !== 'does not exist' && (
                <TextComponent
                  changeHandler={(e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
                    setModifiedData({
                      ...modifiedData,
                      condition: {
                        ...modifiedData['condition'],
                        dateTimeOffset: e.target.value,
                      },
                    });
                  }}
                  data={{
                    value: modifiedData.condition?.dateTimeOffset || '0',
                    label: 'Time Offset (s)',
                    required: true,
                    style: { margin: 1, width: 150 },
                    error: !(
                      !isNaN(modifiedData.condition?.dateTimeOffset) &&
                      !isNaN(parseInt(modifiedData.condition?.dateTimeOffset))
                    ),
                  }}
                />
              )}
            <div>
              <Button
                type="submit"
                fullWidth
                variant="contained"
                sx={{ mt: 1, mb: 2 }}
                aria-controls={open ? 'basic-menu' : undefined}
                aria-haspopup="true"
                aria-expanded={open ? 'true' : undefined}
                onClick={handleDropDownBtClick}
                disabled={!enableCondBt}
              >
                + Condition
              </Button>
              <Menu
                id="basic-menu"
                anchorEl={dropDownBt}
                open={open}
                onClose={handleDropDownBtClose}
                MenuListProps={{
                  'aria-labelledby': 'basic-button',
                }}
              >
                {groups.map((g, num) => (
                  <MenuItem onClick={() => addCondition(num)} key={num}>
                    + Add to Group{num}
                  </MenuItem>
                ))}
                <MenuItem onClick={() => addCondition(-1)}>+ Add New Group</MenuItem>
              </Menu>
            </div>
          </div>
        </Box>
        {configData.sessionManagement && (
          <SessionManagement
            modifiedData={modifiedData}
            changeHandler={(data: any) => setModifiedData(data)}
            sessionTypes="none"
          />
        )}
        <Button
          type="submit"
          fullWidth
          variant="contained"
          sx={{ mt: 3, mb: 2 }}
          onClick={() => {
            submitData(cloneDeep(modifiedData), false);
          }}
          disabled={disableSubmit}
        >
          Save
        </Button>
      </FormControl>
    </>
  );
};

// export default withAITracking(reactPlugin, GenerateConditionalUI);
export default GenerateConditionalUI;
